// import { JobProfileTableStyle } from "./JobProfileTableStyle"

import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export function JobProfileInteractionTable({ data, onDelete, onEdit, options, actions }) {
	const items = [
		{
			name: "con_quien",
			label: "¿Con Quien?",
		},
		{
			name: "para_que",
			label: "¿Para Qué?",
		},
		{
			name: "tipo",
			label: "Tipo",
		},
	]

	return <JobProfileTableStyle {...{ items, data, onDelete, onEdit, options, actions }} />
}
